import { userRouters } from './user'
import { roleRouters } from './role'
import { permissionRouters } from './permission'
import Permissions from '@/permissions'

export const administrationRouters = {
  path: 'administrations',
  name: 'administrations',
  component: () => import('@/views/administrations/Index'),
  redirect: 'gender',
  meta: {
    permissions: [Permissions.backend.setting.manage]
  },
  children: [
    userRouters,
    roleRouters,
    permissionRouters
  ]
}
